<template>
  <div class="public-panel">
    <setup-2FA v-if="getterPopupName === '2FactorAuthentication'" :setup="true" />

    <img src="@/assets/images/header-logo-white.svg" />

    <div class="info-box" v-if="lostDeviceMsg">
      <div class="row">
        <h4 class="title">Device Lost?</h4>
        <u @click="mainScreen">
          <i class="fa fa-angle-left" />Back
        </u>
      </div>

      <p>{{lostDeviceMsg}}</p>
    </div>

    <div class="form" v-else>
      <div v-if="isSetup">
        <h4 class="title">2FA Setup</h4>

        <div class="row-left">
          <u @click="openPopup('2FactorAuthentication')">
            How to setup 2 Factor authentication?
          </u>
        </div>

        <qr-code :value="secretUrl" level="H" :size="200" style="margin-top: 15px;" />
        <md-field class="no-right-border">
          <div class="custom-field">
            <md-input :value="secretKey" disabled />
            <span class="input-suffix" @click="copyText(secretKey)">
              <i class="fa fa-copy" title="Copy API Token" />
            </span>
          </div>
        </md-field>
      </div>

      <h4 class="title" v-if="!isSetup">2FA Verification</h4>

      <md-field :class="{'input-error': $v.otp.$error || errorMsg}">
        <label>OTP</label>
        <md-input v-model="otp" @blur="$v.otp.$touch()" @keyup.enter="verifyOtp"
                  :ref="'OTP'" :maxlength="6" />
      </md-field>
      <h6 class="error-message" v-if="$v.otp.$error && !$v.otp.required">Please enter OTP</h6>
      <h6 class="error-message" v-else-if="$v.otp.$error && !$v.otp.numeric">Please enter only numeric values</h6>
      <h6 class="error-message" v-else-if="$v.otp.$error && !$v.otp.minLength">Please enter valid OTP of 6 characters</h6>
      <h6 class="error-message" v-else-if="errorMsg">{{errorMsg}}</h6>

      <p v-if="!isSetup" class="info-options" @click="lostDevice">Device lost?</p>

      <button @click="verifyOtp">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import QrCode from 'qrcode.vue'
import Setup2FA from '@/components/TFA/Setup2FA'

import ApiServices from '@/services/api/sessions'
import { openPopup, copyText } from '@/utils/helpers'
import { mapGetters, mapMutations } from 'vuex'
import { required, numeric, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'OTP',
  components: { QrCode, Setup2FA },
  data () {
    return {
      secretUrl: '',
      otp: null,
      lostDeviceMsg: null,
      errorMsg: null
    }
  },
  validations: {
    otp: {
      required,
      numeric,
      minLength: minLength(6)
    }
  },
  watch: {
    otp () {
      this.errorMsg = null
    }
  },
  created () {
    if (this.isSetup || this.getterPreviousRoute !== 'Login') {
      this.otpPage()
    }
  },
  mounted () {
    if (!this.isSetup) {
      this.$refs.OTP.$el.focus()
    }
  },
  computed: {
    ...mapGetters(['getterPopupName', 'getterPreviousRoute']),
    secretKey () {
      if (this.secretUrl) {
        const params = this.secretUrl.slice(this.secretUrl.indexOf('?'))
        return new URLSearchParams(params).get('secret')
      }
      return null
    },
    isSetup () {
      return this.$route.name === 'OTPSetup'
    }
  },
  methods: {
    openPopup,
    copyText,
    ...mapMutations(['SET_USER_LOGGED_IN', 'SET_TARGET_PAGE']),
    otpPage () {
      ApiServices.verifyOtpPage().then(response => {
        if (response.success) {
          let data = response.data
          this.secretUrl = data.otp_secret_key

          if (data.page === 'OTP_UNVERIFIED') {
            this.SET_TARGET_PAGE('OTP')
            this.$router.push({name: 'OTP'})
          } else {
            this.SET_TARGET_PAGE('OTP_SETUP')
            this.$router.push({name: 'OTPSetup'})
          }
        } else if (response.reason === 'ALREADY_LOGGED_IN') {
          this.setSessions()
          this.successToastMsg(response.message)
          this.$router.push({name: 'Dashboard'})
        }
      })
    },
    verifyOtp () {
      this.$v.$touch()
      if (!this.$v.$error && !this.errorMsg) {
        ApiServices.verifyOtp({otp: this.otp}).then(response => {
          if (response.success) {
            this.SET_TARGET_PAGE('ANY')
            localStorage.setItem('access_token', response.data.token)
          } else if (response.reason === 'ALREADY_LOGGED_IN') {
            this.setSessions()
            this.successToastMsg(response.message)
          }
          this.$router.push({name: 'Dashboard'})
        }).catch((error) => {
          this.errorMsg = error.body.message
        })
      }
    },
    lostDevice () {
      this.$v.$reset()
      this.errorMsg = null
      this.otp = null

      ApiServices.lostDevice().then(response => {
        if (response.success) {
          this.lostDeviceMsg = response.message
        } else if (response.reason === 'ALREADY_LOGGED_IN') {
          this.setSessions()
          this.successToastMsg(response.message)
          this.$router.push({name: 'Dashboard'})
        }
      })
    },
    setSessions () {
      this.SET_USER_LOGGED_IN()
      this.SET_TARGET_PAGE('ANY')
    },
    mainScreen () {
      this.lostDeviceMsg = null
      setTimeout(() => {
        this.$refs.OTP.$el.focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/publicPanel.scss';
  @import '@/assets/scss/customField.scss';

  .public-panel {
    u {
      text-decoration: none;
      @include normal-text($primary);
      display: inline-block;
      cursor: pointer;
    }

    .custom-field {
      input {
        text-align: center;
      }
    }

    .info-box {
      .row {
        @include custom-flex(space-between);
        margin-bottom: 15px;

        u {
          i {
            margin-right: 5px;
          }
        }
      }
    }
  }
</style>
